import React from 'react'
import { Panel, Container, Button, Label, Toolbar, Image, CheckBoxField } from '@sencha/ext-modern'
import Dialog from '../../components/Dialog'
import Message from '../../components/Message'
import { WX, getUrl } from '../../public'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import './Date.css'

Ext.require('Ext.MessageBox')
const style = {
  outer: {
    backgroundColor: "#f5f5f5",
    padding: "10px",
  },
  innerContainer: {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    margin: "10px",
  },
  contentContainer: {
    padding: "10px",
    fontSize: "12px",
    color: '#838484',
  },
  titleContainer: {
    borderBottom: "1px solid #f5f5f5",
  },
}

class OrderingPlan extends React.Component {
  state = {
    errorMessage: null,
  }

  componentDidMount() {
    this.handleGetDefaultValue(new Date().valueOf())
  }

  handleGetDefaultValue = (date) => {
    Tyan.doPostEvent('WXGetDefaultValue', {
      data: { date },
      onEnd: ({ errorMessage, dateColor, defaultValue }) => {
        if (errorMessage) {
          this.setState({ errorMessage })
        } else {
          this.setState({ date, dateColor, defaultValue })
        }
      },
    })
  }

  handleDayClick = (e) => {
    location.hash = `/QYWX/OrderingDetail/${e}`
  }

  handleChange = (check) => {
    const { date, defaultValue } = this.state
    if (defaultValue !== check)
      Tyan.doPostEvent('WXChangeStatus', {
        data: { check },
        onEnd: ({ errorMessage, }) => {
          if (errorMessage) {
            Tyan.pubForm.showError(errorMessage)
            return
          }
          this.handleGetDefaultValue(date)
        },
      })
  }

  render() {
    const { errorMessage, dateColor, defaultValue } = this.state
    const { match: { params: { type } } } = this.props
    if (errorMessage) {
      return <Message text={`数据加载失败：${errorMessage}`} />
    }/*  else if (!inspectionPlan) {
      return <Message text="数据加载中..." />
    } */
    const panelProps = {
      height: "100%",
      margin: '0 0 0 0',
      padding: '0 0 0 0'
    }

    return (
      <Panel layout="vbox" {...panelProps}>
        <Container layout={{ type: 'hbox', align: 'top', pack: "center" }} padding={"20% 0 0 0"}>
          <Calendar
            formatDay={(l, d) => d.getDate()}
            onClickDay={this.handleDayClick}
            onActiveStartDateChange={({ activeStartDate, value, view }) => this.handleGetDefaultValue(new Date(activeStartDate).valueOf())}
            tileClassName={({ activeStartDate, date, view }) => dateColor && dateColor[date.getMonth() + 1 + '-' + date.getDate()]}
          />
        </Container>
        <Container layout={{ type: 'hbox', align: 'top', pack: "left" }} padding={"0 0 0 30"}>
          <CheckBoxField boxLabel="默认订餐" checked={defaultValue} onUnCheck={() => this.handleChange(false)} onCheck={() => this.handleChange(true)} />
        </Container>
      </Panel>
    )
  }
}

export default OrderingPlan